// take in an object and turn any values into json.stringify
import _ from 'lodash'
export default function nullToEmptyString(obj) {
    let f = {}
    _.forEach(obj, (v, k) => {
        if (v === null) {
            f[k] = ""
        } else {
            f[k] = v
        }
    })

    return f
}
